export default __webpack_public_path__ + "static/media/hiace22.40faea8e.png";